import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { PassValidationService } from 'src/app/validators/pass-validation.service';
import { AdminResponseDto, AdminService, AdminUpdatePassDto } from 'src/generated_client';
import { AuthService } from 'src/app/services/auth/auth.service';
import { WhiteSpaceValidator } from 'src/app/validators/white-space.validator';
import { SnackBarService } from 'src/app/services/snack-bar.service';

@Component({
  selector: 'app-pass-management',
  templateUrl: './pass-management.component.html',
  styleUrls: ['./pass-management.component.css']
})

export class PassManagementComponent implements OnInit {

  adminResponse: AdminResponseDto = {} as AdminResponseDto;
  passUpdate: AdminUpdatePassDto = {} as AdminUpdatePassDto;

  passwordForm: FormGroup = this.fb.group({

    dsPassword: ['', Validators.required],
    dsNewPassword: ['', Validators.compose([Validators.required, WhiteSpaceValidator.cannotContainSpace, Validators.minLength(8)])],
    confirmNew: ['', Validators.required]
  },
    {
      validator: this.validador.passValidator(
        "dsNewPassword",
        "confirmNew"
      )
    }
  )

  constructor(
    private fb: FormBuilder,
    private validador: PassValidationService,
    private adminService: AdminService,
    private authService: AuthService,
    private snackBar: SnackBarService,
    private router: Router
  ) { }

  ngOnInit(): void {

    this.adminResponse = this.authService.currentUser();
  }

  saveChanges(form: any) {

    if (this.passwordForm.valid) {

      this.passUpdate = {
        dsUsername: String(this.adminResponse.dsUsername),
        dsPassword: form.dsPassword,
        dsNewPassword: form.dsNewPassword
      }

      this.adminService.apiAdminChangePasswordPut(this.passUpdate).subscribe(() => {

        this.snackBar.openSnackBar("Contraseña cambiada exitosamente", "Aceptar");
        this.router.navigate(['admin-home']);
      },
        err => {

          this.snackBar.openSnackBar(err.error.error, 'Aceptar');
          this.ResetControls();
        }
      )
    }
  }

  private ResetControls() {
    this.passwordForm.controls['dsPassword'].reset();
    this.passwordForm.controls['dsNewPassword'].reset();
    this.passwordForm.controls['confirmNew'].reset();
  }
}
